import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import TemplateFilterCriteria from './TemplateFilterCriteria'
import TemplateList from './TemplateList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './TemplateAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setTemplateDashboardTemplateList } from '../../store/slice/ManufSlice';

export default function TemplateListView({setShowEdit,setTemplateId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.templateDashboard);   

    const [filteredTemplateList, setFilteredTemplateList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { templateDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (templateDashboard.templateList.length>-1){
        setFilteredTemplateList(templateDashboard.templateList);
        transformToCardFormat(templateDashboard.templateList, setCardList);
      }
    },[templateDashboard.templateList])

    useEffect(()=>{
          transformToCardFormat(filteredTemplateList, setCardList);
      },[filteredTemplateList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.assetname==='' ){
            setFilteredTemplateList(templateDashboard.templateList);
            transformToCardFormat(templateDashboard.templateList, setCardList);

        } else {
            setFilteredTemplateList(
                templateDashboard.templateList
                    .filter(template=> template.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(template=> template.assetname.toString().toUpperCase().includes(filterCriteria.assetname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(templateDashboard.filteredTemplateList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <TemplateList
                    setShowEdit={setShowEdit}
                    setTemplateId = {setTemplateId}
                    tableList={filteredTemplateList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}